import React from 'react'
import PropTypes from 'prop-types'
import BasicItemSkeleton from 'components/skeletons/BasicItemSkeleton'
import { Row } from 'components/qstrap'

const ThumbnailLoader = ({ length }) => (
  <Row>
    {
      [...Array(length)].map((val, i) => (
        <div key={i} className="col-md-4 col-sm-6 m-b-md">
          <BasicItemSkeleton />
        </div>
      ))
    }
  </Row>
)

ThumbnailLoader.propTypes = { length: PropTypes.number }
ThumbnailLoader.defaultProps = { length: 3 }

export default ThumbnailLoader
